
//
// Get tag object based on slug
//
export function useTagBySlug(tagSlug) {
  // Get config from server plugin
  const config = useNuxtApp().$configData
  const tags = config?.wa?.tags
  return tags?.find(tag => useSlugify(tag.label) === tagSlug)
}
